import { Link } from 'react-router-dom';
import { MapPin, Coffee, Droplets } from 'lucide-react';
import StarRating from './StarRating';
import { Badge } from '@/components/ui/badge';

const brewIcons = {
  Espresso: '☕',
  'Hand drip': '🫗',
  Aeropress: '⚗️',
  'French press': '🫖',
  'Cold brew': '🧊',
};

export default function CoffeeCard({ coffee }) {
  return (
    <Link to={`/coffee/${coffee.id}`} className="block group h-full">
      <div className="bg-card rounded-2xl overflow-hidden border border-border hover:border-primary/30 hover:shadow-lg transition-all duration-300 h-full flex flex-col">
        {/* Photo */}
        <div className="relative h-40 shrink-0 bg-muted overflow-hidden">
          {coffee.photo_url ? (
            <img
              src={coffee.photo_url}
              alt={coffee.name}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-amber-50 to-amber-100">
              <Coffee size={48} className="text-amber-300" strokeWidth={1} />
            </div>
          )}
          {coffee.availability === 'Limited time' && (
            <div className="absolute top-3 left-3">
              <Badge className="bg-accent text-accent-foreground text-[10px] font-semibold tracking-wider uppercase">
                Limited
              </Badge>
            </div>
          )}
        </div>

        {/* Content */}
        <div className="p-4 space-y-2 flex-1 flex flex-col">
          <div className="space-y-1">
            <h3 className="font-heading font-semibold text-base leading-tight text-foreground line-clamp-2">
              {coffee.name}
            </h3>
            {coffee.average_rating > 0 && (
              <div className="flex items-center gap-1">
                <StarRating rating={coffee.average_rating} size={13} />
                <span className="text-xs font-semibold text-foreground">
                  {coffee.average_rating.toFixed(1)}
                </span>
              </div>
            )}
          </div>

          <div className="flex items-start gap-1 text-muted-foreground">
            <MapPin size={12} strokeWidth={1.5} className="mt-0.5 shrink-0" />
            <div>
              <p className="text-xs leading-tight">{coffee.cafe_name}</p>
              {coffee.cafe_area && (
                <p className="text-xs text-muted-foreground/60 leading-tight">{coffee.cafe_area}</p>
              )}
            </div>
          </div>

          <div className="flex items-center gap-2 flex-wrap pt-1 mt-auto">
            {coffee.bean_origin && (
              <Badge variant="secondary" className="text-[11px] font-medium">
                {coffee.bean_origin}
              </Badge>
            )}
            {coffee.brew_method && (
              <Badge variant="outline" className="text-[11px] font-medium">
                {brewIcons[coffee.brew_method]} {coffee.brew_method}
              </Badge>
            )}
            {coffee.processing_method && (
              <Badge variant="outline" className="text-[11px] text-muted-foreground">
                <Droplets size={10} className="mr-1" />
                {coffee.processing_method}
              </Badge>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
}